import {useEffect} from 'react';

export default function useViewerAudio(src?: string) {
  useEffect(() => {
    if (src && src !== viewerAudio?.src) {
      viewerAudio = {audioEl: new Audio(src), src};
    }

    return () => {
      viewerAudio?.audioEl.pause();
      viewerAudio = undefined;
    };
  }, [src]);

  return {
    play: () => viewerAudio?.audioEl.play().catch(() => {}),
    pause: () => viewerAudio?.audioEl.pause(),
  };
}

let viewerAudio: {audioEl: HTMLAudioElement; src: string} | undefined;
